module.exports = "img/flags/ZW.e64ce22.png";